import { PROFILE_HEADLINE } from "../../constants"
import { useTheme } from "../../theme/useTheme"
import { Contacts } from "../ui/Contacts"
import { Icon } from "../ui/icons"
import { Section } from "./Section"
import { Box, Link, Typography } from "@mui/material"

export const Header = () => {
    const { breakpoints } = useTheme()

    return (
        <Section sx={{ position: "relative" }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: breakpoints.isFullPage ? "row" : "column",
                    justifyContent: breakpoints.isFullPage ? "space-between" : "center",
                    alignItems: breakpoints.isFullPage ? "flex-start" : "center",
                    gap: 0,
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={(theme) => ({
                            textAlign: "center",
                            // mobile: the name must stay visibly bigger than
                            // the h5 section headings it sits above, so the
                            // clamp floors and caps at the h4 value — desktop
                            // and print keep the plain variant untouched. The
                            // vw term reads the window, not the sheet (an
                            // unscoped clamp would shrink the A4 name when
                            // printing from a narrow window)
                            "@media screen and (max-width: 1139px)": {
                                fontSize: `clamp(1.5rem, 4.5vw, ${theme.typography.h4.fontSize})`,
                            },
                        })}
                    >
                        Wisaroot Lertthaweedech
                    </Typography>
                    <Typography
                        variant="body1"
                        component="h2"
                        sx={{
                            // "&&" doubles specificity — the theme's mobile
                            // text-align:left media rule (hoisted to sheet
                            // end) would otherwise win
                            "&&": { textAlign: "center" },
                        }}
                    >
                        {PROFILE_HEADLINE}
                    </Typography>
                </Box>
                <Contacts variant="header" />
            </Box>
            {
                // print-only line pinned into the section's bottom margin
                // (top:100%, Section is relative) — zero layout presence
            }
            <Typography
                variant="caption"
                component="p"
                sx={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    textAlign: "right",
                    overflow: "hidden",
                    height: "1.2em",
                    lineHeight: "1.2em",
                    visibility: breakpoints.isPdfMode ? "visible" : "hidden",
                }}
            >
                <Link
                    href="https://resume.wisl.dev/"
                    sx={{
                        display: "inline",
                        textDecoration: "none",
                        color: "inherit",
                    }}
                >
                    Interactive version at:{" "}
                    <span style={{ textDecoration: "underline" }}>resume.wisl.dev</span>
                    <Icon
                        name="arrowUpRightFromSquare"
                        style={{
                            fontSize: "0.95em",
                            verticalAlign: "middle",
                            marginLeft: 3,
                            opacity: 0.8,
                        }}
                    />
                </Link>
            </Typography>
        </Section>
    )
}
